<template>
  <el-dialog :title="dataForm.id ? 'Edit Campaign' : 'Add Campaign'" :close-on-click-modal="false" :visible.sync="visible" width="800px" top="3vh">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" autocomplete="off" label-width="186px">
      <el-form-item label="Copy From" prop="copyFromId" key="copyFromId" v-if="!dataForm.id">
        <Campaign-select-remote-search
          v-model="dataForm.copyFromId"
          placeholder="Select an existing data to copy"
          @change-item="copyFromChange"
        ></Campaign-select-remote-search>
      </el-form-item>
      <el-form-item label="Title" prop="title" key="title">
        <el-input v-model="dataForm.title" placeholder="title" clearable></el-input>
      </el-form-item>
      <el-form-item label="Template" prop="templateId" key="templateId">
        <el-select v-model="dataForm.templateId" placeholder="Select Template" filterable class="wdb100">
          <el-option v-for="item in templateList" :key="`template-${item.id}`" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Tags" prop="tagIds" key="tagIds">
        <el-select v-model="dataForm.tagIds" filterable multiple clearable class="wdb100">
          <el-option v-for="item in tagInfoList" :key="`tag-${item.id}`" :label="item.tagName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Send Type" prop="sendType" key="sendType">
        <el-select v-model="dataForm.sendType" placeholder="Select Send Type" class="wdb100">
          <el-option v-for="item in marketingEmailPushTypeList" :key="`sendType-${item.value}`" :label="item.title" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Scheduled Send Time" prop="scheduledTime" key="scheduledTime" v-if="dataForm.sendType == 2">
        <el-date-picker
          v-model="dataForm.scheduledTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="Scheduled Send Time"
          :picker-options="scheduledTimePickerOptions"
          class="wdb100"
          popper-class="hideNowBtn"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="Remark" prop="remark" key="remark">
        <el-input v-model="dataForm.remark" type="textarea" :rows="5" :autosize="{ minRows: 4 }" resize="none" placeholder="Remark"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import validatorMixin from "@/mixins/validatorMixin";
import CampaignSelectRemoteSearch from "@/components/SelectRemoteSearch/campaign";
export default {
  mixins: [validatorMixin],
  components: {
    CampaignSelectRemoteSearch,
  },
  props: {
    templateList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    tagInfoList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      visible: false,
      dataForm: {
        id: null,
        title: "",
        templateId: null,
        tagIds: [],
        sendType: null,
        scheduledTime: null,
        remark: "",
      },
      dataRule: {
        title: [{ required: true, message: "please enter", trigger: "submit" }],
        templateId: [{ required: true, message: "please select", trigger: "submit" }],
        tagIds: [{ type: "array", required: true, message: "please select", trigger: "submit" }],
        sendType: [{ required: true, message: "please select", trigger: "submit" }],
        // 仅 Send Type 为 2 (Schedule Send) 时该项才渲染并参与校验, 配合模板中的 v-if
        scheduledTime: [
          { required: true, message: "please select", trigger: "submit" },
          { validator: this.validateFutureTime, trigger: "submit" },
        ],
      },
      submitLoading: false,
    };
  },
  computed: {
    ...mapState("constant", ["marketingEmailPushTypeList"]),
    // 定时发送时间: 日历面板禁用今天之前的日期 (今天保留, 当天已过时刻由校验规则拦截)
    scheduledTimePickerOptions() {
      return {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      };
    },
  },
  methods: {
    // 初始化
    async init(data) {
      console.log(data);
      this.submitLoading = false;
      this.visible = true;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      if (data) {
        const dataCopy = JSON.parse(JSON.stringify(data));
        // 修改
        const tagIds = dataCopy.tags?.map(i => i.id) || [];
        this.dataForm = {
          id: dataCopy.id,
          title: dataCopy.title,
          templateId: dataCopy.templateId || null,
          tagIds,
          sendType: dataCopy.sendType,
          scheduledTime: dataCopy.scheduledTime,
          remark: dataCopy.remark,
        };
      } else {
        this.$set(this.dataForm, "id", null);
        this.dataForm.scheduledTime = null;
      }
    },
    // Copy From 选中值发生改变时
    copyFromChange(data) {
      if (!data) return;
      this.$set(this.dataForm, "title", data.title);
      this.$set(this.dataForm, "templateId", data.templateId || null);
      const tagIds = data.tags?.map(i => i.id) || [];
      this.$set(this.dataForm, "tagIds", tagIds);
      this.$set(this.dataForm, "sendType", data.sendType);
      this.$set(this.dataForm, "scheduledTime", data.scheduledTime);
      this.$set(this.dataForm, "remark", data.remark);
    },
    // 表单提交
    async formSubmitRequest() {
      const params = { ...this.dataForm };
      if (params.sendType == 1) {
        params.scheduledTime = null;
      }
      if (params.id) {
        return await this.$http.post(`/admin/promoEmailPush/${params.id}/update`, params);
      } else {
        return await this.$http.post("/admin/promoEmailPush/create", params);
      }
    },
    dataFormSubmit() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          this.submitLoading = true;
          this.formSubmitRequest(this.dataForm)
            .then(res => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch(err => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="scss">
// 隐藏 datetime 面板底部的 Now 按钮: 点击会把值设为当前时刻, 与"必须晚于当前时间"的校验冲突
.hideNowBtn {
  .el-picker-panel__footer {
    .el-picker-panel__link-btn:first-child {
      display: none !important;
    }
  }
}
</style>
